"use client";
import { createContext, useContext, useMemo, type ReactNode } from "react";
import { dirOf, type UiLocale } from "./config";
import { makeFormatters } from "./format";
import { makeT } from "./translate";

const Ctx = createContext<UiLocale>("en");

/** Provides the dashboard language to client components (messages are bundled; only the locale is passed). */
export function I18nProvider({ locale, children }: { locale: UiLocale; children: ReactNode }) {
  return <Ctx.Provider value={locale}>{children}</Ctx.Provider>;
}

export function useLocale() {
  return useContext(Ctx);
}

export function useT() {
  const locale = useContext(Ctx);
  return useMemo(() => makeT(locale), [locale]);
}

export function useI18n() {
  const locale = useContext(Ctx);
  return useMemo(() => ({ locale, dir: dirOf(locale), t: makeT(locale), f: makeFormatters(locale) }), [locale]);
}
